import React from 'react';
import type { TimeLeft } from '../hooks/useCountdown';
type CountdownProps = {
  time: TimeLeft;
  size?: 'lg' | 'sm';
  tone?: 'light' | 'dark';
};
export function Countdown({
  time,
  size = 'lg',
  tone = 'dark'
}: CountdownProps) {
  const units = [{
    value: time.days,
    label: 'days'
  }, {
    value: time.hours,
    label: 'hrs'
  }, {
    value: time.minutes,
    label: 'min'
  }, {
    value: time.seconds,
    label: 'sec'
  }];
  const isLarge = size === 'lg';
  const box = tone === 'dark' ? 'bg-sage-dark/60 text-cream border-sage-line' : 'bg-white text-ink border-sand-dark';
  const label = tone === 'dark' ? 'text-cream/60' : 'text-ink-muted';
  return <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Launch price ends in ${time.days} days ${time.hours} hours ${time.minutes} minutes`} data-id="element-85" data-mp="3262rkas34dga">
      {units.map(unit => <div key={unit.label} className={`rounded-xl border text-center tabular-nums ${box} ${isLarge ? 'px-2 py-3 sm:px-5 sm:py-4 min-w-[66px] sm:min-w-[88px]' : 'px-2 py-2 min-w-[56px]'}`} data-id="element-86" data-mp="15a504ck7pzg4">
          <div className={`font-display leading-none ${isLarge ? 'text-3xl sm:text-5xl' : 'text-2xl'}`} data-id="element-87" data-mp="17rhsd6kyox2c">
            {unit.value}
          </div>
          <div className={`mt-1 font-bold uppercase tracking-widest ${label} ${isLarge ? 'text-[10px]' : 'text-[9px]'}`} data-id="element-88" data-mp="12u9890g96iyg">
            {unit.label}
          </div>
        </div>)}
    </div>;
}